import { InfoBanner } from '@ui';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { RandomizationResultType } from '@/api/apis/case';

export const RandomizationResultBanner = () => {
  const { randomization } = useBaseCaseDetails();

  const isRandomizedOCS = randomization?.result === RandomizationResultType.OCS;
  const isRandomizedSCS = randomization?.result === RandomizationResultType.SCS;
  const isRandomized = isRandomizedOCS || isRandomizedSCS;

  return isRandomized ? (
    <InfoBanner title="Randomization completed" iconType="success" withClose>
      <div className="flex gap-1 flex-wrap">
        <span className="text-m-r">The randomization outcome:</span>
        <span className="text-m-sb">{isRandomizedOCS ? 'OCS (Organ Care System).' : 'SCS (Static Cold Storage).'}</span>
      </div>
    </InfoBanner>
  ) : null;
};
